const IDC_EXPLAIN = {
  xh: '徐汇-xh',
  gq: '桂桥-gq',
  dba: '数北A-dba',
  sdyd: '山东移动-sdyd',
  gz: '广州-gz',
  cd: '成都-cd',
  gg: '硅谷-gg',
  tencent: '腾讯-tencent',
  cq: '次渠-cq',
  zw: '中卫-zw',
  gh: '光环-gh',
  nh: '南汇-nh',
  sdlt: '山东联通-sdlt',
  nj: '南京-nj',
  tx: '上海一区-tx',
  dld: '多伦多一区-dld',
  ts: '唐山-ts',
  rz: '润泽-rz',
  wj: '望京-wj',
  yf: '永丰-yf',
  yy: '易园-yy',
  hk: '香港一区-hk',
  yz: '扬州-yz',
  dx: '大兴-dx',
  bs: '宝山-bs',
  yp: '月浦-yp',
  sjz: '石家庄-sjz',
  kh: '科华-kh',
  sb: '市北-sb',
  kx: '天津-kx'
};
const STATUS_EXPLAIN = {
  0: '已停止', 1: '运行状态', 2: 'worker更新中',
  3: '异常停止',
  4: '手动停止',
  5: '依赖不存在',
  6: '停止命令下发中',
  7: '状态不存在',
  8: '进程停止',
  9: '命令下发失败'
};

const COLOR_EXPLAIN = {
  0: '#BEBEBE',
  1: '#A1D6E4',
  2: '#01DFD7',
  3: '#F7ba2a',
  4: '#F78181',
  5: '#F5A9A9',
  6: '#01DFD7',
  8: '#878D99'
};
export default {
  //idc to String
  idcExplain(idc) {
    return IDC_EXPLAIN[idc] ? IDC_EXPLAIN[idc] : idc
  },
  //时间格式化
  timeFormat(val) {
    var date = new Date(val);
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = (Array(2).join(0) + date.getDate()).slice(-2) + ' ';
    var h = (Array(2).join(0) + date.getHours()).slice(-2) + ':';
    var m = (Array(2).join(0) + date.getMinutes()).slice(-2) + ':';
    var s = (Array(2).join(0) + date.getSeconds()).slice(-2);
    return Y + M + D + h + m + s;
  },
  //选择颜色
  switchColor(val) {
    return COLOR_EXPLAIN[val] ? COLOR_EXPLAIN[val] : '#FA5555'
  },
  statusExplain(val) {
    return STATUS_EXPLAIN[val] ? STATUS_EXPLAIN[val] : '无效状态'
  }
}



// WEBPACK FOOTER //
// ./src/views/util/commonUtil.js